import type NumberUnit from '@exodus/currency';
import { useMemo } from 'react';
import { useSelector } from 'react-redux';

import selectors from '@/ui/flux/selectors';

type ExchangeStatusState = {
  status: 'started' | 'inProgress' | 'complete' | 'failed';
  error?: string | null;
  fromAmount: NumberUnit;
  fromAssetName: string;
  orderId: string;
  toAmount: NumberUnit;
  toAssetName: string;
};

type ExchangeResult = ExchangeStatusState & { userRejected?: boolean };

function useExchangeResult(): Partial<ExchangeResult> {
  const state = useSelector<unknown, ExchangeStatusState | null>(
    selectors.exchange.status,
  );

  return useMemo(
    () => ({
      ...state,
      userRejected: state?.error?.includes('The user rejected the request'),
    }),
    [state],
  );
}

export default useExchangeResult;
